import * as React from 'react';

import { Props } from './types';

const UserIcon = ({ className }: Props) => (
  <svg
    data-testid="user-icon"
    className={className}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <path
      d="M4 4.80002C4.972 4.80002 5.6 4.07203 5.6 2.60002C5.6 1.12802 4.972 0.400024 4 0.400024C3.028 0.400024 2.4 1.14002 2.4 2.61202C2.4 4.08402 3.028 4.80002 4 4.80002ZM7.056 6.36402L5.396 5.61602C4.9956 5.85722 4.5124 6.00002 3.996 6.00002C3.4796 6.00002 2.9964 5.85723 2.5836 5.60923L0.944 6.37602C0.3828 6.63282 0 7.18923 0 7.83523C0 7.83563 0 7.83562 0 7.83602V8.00003H8V7.83602C8 7.83602 8 7.83563 8 7.83523C8 7.18923 7.6172 6.63282 7.066 6.38002L7.056 6.36402Z"
      fill="#546D91"
    />
  </svg>
);

export default UserIcon;
